// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZFXEW-fCgVaXTRmmDnzYjtgleCA-6GrA",
  authDomain: "fruity-bd.firebaseapp.com",
  projectId: "fruity-bd",
  storageBucket: "fruity-bd.appspot.com",
  messagingSenderId: "968714509441",
  appId: "1:968714509441:web:5937a68946feccb0b74180"
};
  export default firebaseConfig;